import { createContext, useContext } from 'react';
import { FilterContext } from './FilterContext';

export const QueryContext = createContext<any>([]);

export const QueryProvider = ({ children }: any) => {
	const [
		{
			// eslint-disable-next-line
			searchTerms,
			lang,
			freq,
			corpus,
			graphViewmode,
			case_sens,
			leaves,
			limit,
		},
	] = useContext(FilterContext);

	let queryString = `https://api.nb.no/dhlab/nb_ngram/ngram/query?terms=${
		searchTerms.length && searchTerms[0].length
			? encodeURIComponent(searchTerms.toString())
			: 'nasjonalbiblioteket'
	}&lang=${lang || 'nob'}&case_sens=${case_sens ? 1 : 0}&freq=${
		freq || 'rel'
	}&corpus=${corpus.length ? encodeURIComponent(corpus.toString()) : 'bok'}`;

	if (graphViewmode === 'råfrekvens') {
		queryString = `https://api.nb.no/dhlab/nb_ngram/freq/query?terms=${
			searchTerms.length
				? encodeURIComponent(searchTerms.toString())
				: 'språk og *'
		}&lang=${lang}&corpus=${corpus[0]}`;
	} else if (graphViewmode === 'galakser') {
		queryString = `https://api.nb.no/dhlab/nb_ngram_galaxies/galaxies/query?terms=${
			searchTerms.length
				? encodeURIComponent(searchTerms.toString())
				: 'skriver'
		}&lang=${'nob'}&corpus=${corpus[0]}&limit=${limit}&leaves=${
			leaves ? 1 : 0
		}`;
	}

	return (
		<QueryContext.Provider value={[queryString]}>
			{children}
		</QueryContext.Provider>
	);
};
